import {Pipe, PipeTransform} from '@angular/core';
import {has} from 'lodash';
import {MenuNavItem, GroupMenuItem, MenuItem} from './../../../../app.constants';

@Pipe({
  name: 'isRouteActive',
  standalone: true,
})
export class IsRouteActivePipe implements PipeTransform {
  transform(route: MenuNavItem, currentUrl: string): boolean {
    if (!route || !currentUrl) return false;

    // Check if it's a GroupMenuItem (has children)
    if (has(route, 'children')) {
      const groupRoute = route as GroupMenuItem;
      return groupRoute.children.some(child => child.url && currentUrl.startsWith(child.url));
    }

    // Check if it's a MenuItem (has url)
    if (has(route, 'url')) {
      const menuRoute = route as MenuItem;
      if (!menuRoute.url) return false;
      if (currentUrl.startsWith(menuRoute.url)) return true;
      const relatedUrls = menuRoute.meta?.relatedUrls as string[] | undefined;
      return relatedUrls?.some(url => currentUrl.startsWith(url)) ?? false;
    }

    return false;
  }
}
